export default __webpack_public_path__ + "static/media/226.5a81419c.svg";